import { AspectRatio, Box, SimpleGrid, Stack, Text } from "@chakra-ui/react";
import PampaImage from "@raiden/library/components/PampaImage";
import useTranslate from "@raiden/library/hooks/useTranslate";
import generateFrontPath from "@raiden/library/libraries/utils/generateFrontPath";
import { FormattedMessage } from "react-intl";
import { CenteredContent } from "../CenteredContent";
import { DataHandler } from "../DataHandler";
/**
 * @typedef {object} Props
 * @property {import("swr").SWRResponse<import("@raiden/library/types/Api/ApiResponse").ApiResponse<import("@raiden/library/types/Post").Post[]>>} swrResponseArticleExpertiseList
 */
/**
 * @param {Props} props
 */
export function ExpertiseAreas({ swrResponseArticleExpertiseList }) {
  const translate = useTranslate();

  return (
    <DataHandler
      swrResponse={swrResponseArticleExpertiseList}
      keepDataOnRevalidation={true}
      renderNoResultSplash={false}
      wrapper={(children) => <Box px="1.25rem">{children}</Box>}>
      {({ data: articleList }) => {
        return (
          <Box padding="3rem .625rem">
            <CenteredContent>
              <Stack spacing="1.5rem">
                <Stack spacing=".5rem">
                  <Text variant="h1">
                    <FormattedMessage defaultMessage="Nos domaines d'expertise" />
                  </Text>

                  <Text variant="h2">
                    <FormattedMessage defaultMessage="Notre équipe vous accompagne après des sinistres importants auprès des assureurs" />
                  </Text>
                </Stack>

                <SimpleGrid
                  columns={{ base: 1, md: 2, xl: 3 }}
                  spacing="1.5rem">
                  {articleList.map((post) => (
                    <Stack spacing="1.5rem" key={post.id}>
                      <Box>
                        <AspectRatio ratio={437 / 245}>
                          <PampaImage
                            image={post.current_revision?.cover}
                            format="small"
                            mode="crop"
                            placeholderSrc={generateFrontPath({
                              id: "@front.internal-assets",
                              parameters: { filePath: "placeholder.png" },
                              includeBasePath: true,
                            })}
                            _hover={{
                              transform: "scale(1.1)",
                            }}
                            transition="all 0.25s ease"
                            alt=""
                          />
                        </AspectRatio>
                      </Box>

                      <Box>
                        <Text variant="h4" mb=".5rem" noOfLines={2}>
                          {translate(post.current_revision?.title)}
                        </Text>

                        <Text noOfLines={4}>
                          {translate(post.current_revision?.summary)}
                        </Text>
                      </Box>
                    </Stack>
                  ))}
                </SimpleGrid>
              </Stack>
            </CenteredContent>
          </Box>
        );
      }}
    </DataHandler>
  );
}
